import * as IconSelector from '../icons';

export const tiposExpedicion = [
    {
        value: 'Expedicion',
        label: 'Expedicion',
        description: 'Expedicion',
        icon: IconSelector.PointIcon,
        color: 'Green'
    },
    {
        value: 'Cambio Uso',
        label: 'Cambio Uso',
        description: 'Cambio de Uso',
        icon: IconSelector.PointIcon,
        color: 'DarkOrange'
    },
    {
        value: 'Devolucion',
        label: 'Devolucion',
        description: 'Devolucion',
        icon: IconSelector.PointIcon,
        color: 'DarkRed'
    }
];
